import { useTranslation } from "react-i18next";

// 骨架屏通用组件
const Skeleton = ({ className }: { className?: string }) => (
  <div
    className={`animate-pulse bg-gray-100 rounded ${className}`}
  />
);

// 标签组件（与原始组件保持一致）
const Label = ({ label, required = true }: { label: string; required?: boolean }) => {
  return (
    <label className='flex w-48 mb-2.5'>
      <span className='text-sm font-medium text-[rgba(52,64,84,1)] mr-0.5'>{label}</span>
      <span className='text-[rgba(117,66,247,1)]'>{required ? '*' : ''}</span>
    </label>
  );
};

/** 个人智能体信息骨架屏 */
export const SkeletonPersonalAgentInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="relative pb-6 border-b border-[rgba(233,234,235,1)]">
      {/* 标题骨架屏 */}
      <div className='text-lg font-semibold text-[rgba(16,24,40,1)] mb-6'>
        <Skeleton className="h-6 w-40" />
      </div>

      {/* 主要内容区域骨架屏 */}
      <div className="flex gap-4">
        {/* 头像上传区域骨架屏 */}
        <div className='min-w-80'>
          <Skeleton className='w-20 h-5 mb-2.5' />
          <div className="flex">
            <Skeleton className='size-16 rounded-full mr-5 flex-shrink-0' />
            <div className="flex flex-col">
              <Skeleton className="h-4 w-32 mb-2" />
              <Skeleton className="h-3 w-60 mb-4" />
              <Skeleton className="w-[70px] h-8 rounded-sm" />
            </div>
          </div>
        </div>

        {/* 用户名输入区域骨架屏 */}
        <div className='min-w-80'>
          <Skeleton className='w-20 h-5 mb-2.5' />
          <Skeleton className='h-10 rounded-sm mb-2' />
          <Skeleton className="h-3 w-56" />
        </div>

        {/* 个人职称输入区域骨架屏 */}
        <div className='w-full'>
          <Skeleton className='w-20 h-5 mb-2.5' />
          <Skeleton className='h-28 rounded-sm mb-2' />
          <Skeleton className="h-3 w-56" />
        </div>

        <div className='w-full'>
          <Skeleton className='w-20 h-5 mb-2.5' />
          <Skeleton className='h-28 rounded-sm mb-2' />
        </div>
      </div>
    </div>
  );
};